import { render, staticRenderFns } from "./SubSection.vue?vue&type=template&id=07889774&scoped=true&"
import script from "./SubSection.vue?vue&type=script&lang=js&"
export * from "./SubSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07889774",
  null
  
)

export default component.exports